<template>
  <div class="register-container is--register animate__animated">
    <template v-if="template === '2'">
      <VTemplate02 :name="name" :nav="!workbench" :workbench="workbench" @next="emit('next')">
        <template #header v-if="$slots.header">
          <slot name="header" />
        </template>
        <template #default v-if="mounted">
          <slot />
        </template>
      </VTemplate02>
      
    </template>
    <template v-else>
      <VTemplate01 :name="name" :nav="!workbench" :workbench="workbench" @next="emit('next')">
        <template #header v-if="$slots.header">
          <slot name="header" />
        </template>
        <template #default v-if="mounted">
         
          <slot />
        </template>
      </VTemplate01>
    </template>
  </div>
</template>

<script setup>
  import { onMounted, ref, watch, computed, inject, provide } from 'vue'
  import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
  import { useRegister } from '@/hooks/useRegister'
  import { getInformation } from '@/api/registration'
  import { getPageConfig, getSteps } from '@/api/config'
  import { ElMessage, ElLoading } from 'element-plus'
  import Loading from '@/components/Loading'
  import { useRoute, useRouter } from 'vue-router'
  import { storeToRefs } from 'pinia'
  import { useAppStore } from '@/store/modules/app'

  import VTemplate01 from './template/1/index.vue'
  import VTemplate02 from './template/2/index.vue'

  const props = defineProps({
    name: {
      type: String,
      default: '',
    },
    nav: {
      type: Boolean,
      default: true,
    },
    workbench: {
      type: Boolean,
      default: false,
    },
    checkout:{
      type: Boolean,
      default: false,
    }
  })
  const { template } = storeToRefs(useAppStore())

  const route = useRoute()
  const router = useRouter()
  const pages = inject('$steps')

  console.log('route', route.name)

  const $event = inject('$event')
  const emit = defineEmits(['next'])
  //const pages = ref([])
  const pageConfig = ref({})
  const information = ref({})
  const mounted = ref(false)
  const loading = ref(true)

  const page = computed(() => {
    let obj = { current: null, prev: null, next: null }
    for (var i = 0, len = pages.value.length; i < len; i++) {
      let it = pages.value[i]
      if (it.Name == props.name) {
        obj.current = it
        if (i > 0) {
          obj.prev = pages.value[i - 1]
        }
        if (i < len - 1) {
          obj.next = pages.value[i + 1]
        }
        break
      }
    }
    return obj
  })

  //
  onMounted(async () => {
    mounted.value = false
    const { data: y } = await getPageConfig(props.name)
    pageConfig.value = y
    if (props.name !== 'login') {
      try {
        const { data: z } = await getInformation()
        information.value = z
        console.log('information=', information.value)
        if (information.value.steps.indexOf(route.name) < 0 && !props.workbench) {
          //
          router.push({ name: information.value.steps[information.value.steps.length - 1] })
        }
      } catch (e) {
        if (e && e.ret != 0) {
          router.push({ name: 'index' })
        }
      }
    }
    emit('mounted', { pageConfig: pageConfig.value, information: information.value })
    mounted.value = true

    if (!page.value.current&& !props.workbench) {
      router.push({ name: 'index' })
    }
  })

  //
  provide('$config', pageConfig)
  provide('$information', information)
</script>
